import { createFeatureSelector, createSelector } from '@ngrx/store';
import { notificationFeatureKey, AuthPartialState } from '../reducers/notification.reducer';
import { MyNotification } from '@models/my-notification';

export const getNotificationState = createFeatureSelector<AuthPartialState, MyNotification>(
  notificationFeatureKey
);

export const selectNotificationState = createSelector(getNotificationState, state => state);

export const authQuery = {
  selectNotificationState
};
